module.exports = __webpack_public_path__ + "img/c11dc51d4b80d29588001ffd9252e74f.png";